module.exports = __webpack_public_path__ + "static/media/satisfaction.581cc8a5.png";